import {
  AlertTriangle,
  ArrowLeftIcon,
  Check,
  Pencil,
  Trash2,
  Info,
  Plus,
  X,
} from "lucide-react";
import React from "react";

export interface ButtonProps {
  type?: "button" | "submit" | "reset";
  text: string;
  onClick?: () => void;
  variant?:
    | "edit"
    | "delete"
    | "info"
    | "create"
    | "save"
    | "cancel"
    | "primary"
    | "back"
    | "auth"
    | "danger";
  icon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

export function Button({
  type = "button",
  text,
  onClick = () => {},
  variant,
  icon,
  className,
  disabled = false,
}: ButtonProps) {
  const baseStyles = "flex items-center font-semibold rounded transition";

  const variantStyles = {
    edit: "bg-blue-500 text-white hover:bg-blue-600 px-3 py-2",
    delete: "bg-red-500 text-white hover:bg-red-600 px-3 py-2",
    info: "bg-gray-500 text-white hover:bg-gray-600 px-3 py-2",
    create: "bg-green-500 text-white hover:bg-green-600 px-3 py-2",
    save: "bg-green-500 text-white hover:bg-green-600 px-3 py-2",
    cancel: "border border-red-500 text-red-500 hover:bg-red-50 px-3 py-2",
    primary: "bg-blue-600 text-white hover:bg-blue-700 px-3 py-2",
    back: "text-gray-700 hover:text-gray-900 transition-colors items-center rounded-lg mb-4",
    auth: "w-full bg-lime-600 text-white hover:bg-lime-700 px-4 py-2.5 shadow-sm justify-center",
    danger: "bg-red-500 text-white hover:bg-red-600 px-3 py-2",
  };

  const disabledStyles = "opacity-50 cursor-not-allowed";

  const defaultIcons = {
    edit: <Pencil className="w-4 h-4 mr-1" />,
    delete: <Trash2 className="w-4 h-4 mr-1" />,
    info: <Info className="w-4 h-4 mr-1" />,
    create: <Plus className="w-4 h-4 mr-1" />,
    save: <Check className="w-4 h-4 mr-1" />,
    cancel: <X className="w-4 h-4 mr-1" />,
    back: <ArrowLeftIcon className="w-5 h-5 mr-2" />,
    danger: <AlertTriangle className="w-4 h-4 mr-1" />,
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick();
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      className={`${baseStyles} 
        ${variant ? variantStyles[variant] : ""} 
        ${disabled ? disabledStyles : ""}
        ${className}
      `}
      disabled={disabled}
      aria-disabled={disabled}
    >
      {variant !== "primary" &&
        variant !== "auth" &&
        (icon || (variant ? defaultIcons[variant] : null))}
      {text}
    </button>
  );
}
